module.exports = __webpack_public_path__ + "static/media/web.da76b1a6.jpg";